<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        6.4.2018
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Erste sexcare Schulung für männliche Sexualbegeiter</h3>
      <div class="mb-1 text-body-secondary">6.4.2018</div>
      <p>Wir freuen uns, anfangs Mai die erste Schulung für Sexualbegleiter durchzuführen
        und somit auch der Damenwelt die Möglichkeit zu bieten, eine erfüllte Sexualität leben zu können!
        Falls Sie eine betroffene Frau sind oder sich als Beauftragte/r oder Institution für unser Angebot interessieren
        oder gerne über sexcare männliche Sexualbegleiter buchen möchten, wir halten Sie gerne mit unserem newsletter
        auf dem Laufenden.
        Ganz einfach unter registrieren und Sie werden über alle unsere aktuellsten Tätigkeiten
        informiert.
        Hier ein kleine Kostprobe von einem unserer <q>coming soon</q>
      </p>
      <h5>Sexualbegleiter: Laszlo Was ist Sex? </h5>
      <p>Eigentlich eine einfache Frage
        für etwas, was die meisten schon gemacht
        haben und regelmässig tun, doch Sex ist
        nicht für jeden das Gleiche.
        Porno ist nicht das, was ich unter Sex
        verstehe. Das, was man bei Pornos sieht, ist
        nur ein Teil von dem, was Sex bietet.
        Sex heisst für mich in erster Linie
        gegenseitigen Respekt und Akzeptanz.
        Sex heisst stimulieren, Zärtlichkeiten
        austauschen, den ganzen Körper streicheln,
        den Nacken, Bauch, Schenkel, Brüste
        küssen, erogene Zonen erkunden, auf das
        eingehen, was der Partner gerne möchte,
        Erregung, Leidenschaft, völlige Hingabe, …
        Ich möchte der Partnerin auf Zeit das geben, wovon sie schon die längste Zeit geträumt hat und dies
        mit sehr viel Freude, Zufriedenheit, Geborgenheit, Erregung, Lust, Leidenschaft und Hingabe.
      </p>
    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog3_1.jpg" alt="sexcare bild" width="250">
    </div>
  </div>

</div>
